// extracted by mini-css-extract-plugin
export var addToCartButton = "_pj-b";
export var arrowButtonContainer = "_pj-9";
export var arrowButtonIcon = "_pj-a";
export var carouselArrowButton = "_pj-6";
export var carouselElementContainer = "_pj-1";
export var galleryThumbnail = "_pj-d";
export var galleryThumbnailImage = "_pj-e";
export var left = "_pj-7";
export var productDisplayCarouselContainer = "_pj-0";
export var productTileContainer = "_pj-2";
export var productTileImage = "_pj-4";
export var productTileImageContainer = "_pj-3";
export var productTileTitle = "_pj-5";
export var right = "_pj-8";
export var sliderOverflow = "_pj-c";